import { Container } from 'react-bootstrap';
import React from 'react';
import { useCallback } from 'react';
import { useContext } from 'react';
import { ToastContext } from './context/ToastContext';
import { useEffect } from 'react';
import { useState } from 'react';
import { LoadingContext } from './context/LoadingContext';

const HelpPage = ({}) => {
    const { finishLoading, startLoading } = useContext(LoadingContext);
    const { sendMessage } = useContext(ToastContext);

    const [helpContent, setHelpContent] = useState([]);
    const [isContentLoaded, setIsContentLoaded] = useState(false);

    const fetchHelpPageContent = useCallback(async () => {
        try {
            await startLoading();
            setIsContentLoaded(false);
            const url = new URL('/api/faqs/helpContent', process.env.APP_URL);
            const response = await fetch(url, {
                headers: { 'Content-Type': 'application/json' },
            });
            if (!response.ok)
                throw new Error('Something went wrong.');
            const data = await response.json();
            if (data.error || !data.helpContent)
                throw new Error(data.error ?? 'Something went wrong.');
            setHelpContent(data.helpContent);
            setIsContentLoaded(true);
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            await finishLoading();
        }
    }, []);

    useEffect(() => {
        fetchHelpPageContent();
    }, []);

    return <Container>
        <h1>HELP</h1>
        <hr />
        {isContentLoaded === true
            ? (helpContent.reduce(
                (faqCount, category) => faqCount + category.Faqs.length,
                0,
            ) > 0
                ? <>
                    <p>
                        <strong>
                            Find quick answers to your questions below...
                        </strong>
                    </p>
                    {helpContent.filter((category) => category.Faqs?.length > 0)
                        .map((category, categoryIndex) => (<>
                            <h2
                                key={categoryIndex}>{category.title}</h2>
                            <ul>
                                {category.Faqs.map((faq, faqIndex) => (<li
                                    key={faqIndex}>
                                    <a
                                        href={`/faq/${category.handle}#${faq.id}`}
                                        dangerouslySetInnerHTML={{ __html: faq.question }}>
                                    </a>
                                </li>))}
                            </ul>
                        </>))
                    }
                </>
                : <p>Sorry, there is no help content available at the moment.</p>)
            : <p>Fetching help content...</p>
        }
    </Container>;
};

export default HelpPage;